import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Header } from "./Header";
import { Footer } from "./Footer";

export const LegalSection = ({ title, children }) => (
  <section className="border-t border-cs-navy/10 pt-8">
    <h2 className="font-display text-xl font-bold tracking-tight text-cs-navy md:text-2xl">{title}</h2>
    <div className="legal-body mt-4">{children}</div>
  </section>
);

export const LegalLayout = ({ eyebrow, title, updated, testId, children }) => (
  <div data-testid={testId}>
    <Header />
    <div className="bg-cs-navy pb-14 pt-32 md:pb-20 md:pt-40">
      <div className="mx-auto max-w-3xl px-5 sm:px-8">
        <Link to="/" data-testid="legal-back-home" className="nav-link inline-flex items-center gap-2 text-sm font-semibold text-white/70">
          <ArrowLeft className="h-4 w-4" /> Retour à l'accueil
        </Link>
        <span className="eyebrow mt-8 !flex !text-cs-yellow">{eyebrow}</span>
        <h1 data-testid="legal-title" className="mt-3 font-display text-4xl font-extrabold tracking-tighter text-white sm:text-5xl">{title}</h1>
        <p data-testid="legal-updated" className="mt-4 text-sm text-white/60">Dernière mise à jour : {updated}</p>
      </div>
    </div>
    <main className="bg-white py-14 md:py-20">
      <div className="mx-auto flex max-w-3xl flex-col gap-10 px-5 sm:px-8">{children}</div>
    </main>
    <Footer />
  </div>
);
